import { useCallback, useReducer } from "react";

import { WorkOpportunitiesTab } from "../constants/work_opportunities_tab";

type UseTabDataReturn<ITEM_TYPE> = [
  (tab: WorkOpportunitiesTab) => ITEM_TYPE,
  (data: ITEM_TYPE, tab: WorkOpportunitiesTab) => void
];

export const useTabData = <ITEM_TYPE extends object | null>(
  defaultData: ITEM_TYPE
): UseTabDataReturn<ITEM_TYPE> => {
  const reducer = (
    state: Partial<Record<WorkOpportunitiesTab, ITEM_TYPE>>,
    action: { type: WorkOpportunitiesTab | null; payload: ITEM_TYPE }
  ) => {
    if (action.type) {
      return { ...state, [action.type]: action.payload };
    } else {
      return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, {});

  const setData = useCallback(
    (data: ITEM_TYPE, tab: WorkOpportunitiesTab) => dispatch({ type: tab, payload: data }),
    [dispatch]
  );

  const getData = useCallback(
    (tab: WorkOpportunitiesTab | null): ITEM_TYPE => (tab && state[tab]) || defaultData,
    [state, defaultData]
  );

  return [getData, setData];
};
